export enum InvestigatorServiceActions {
  ALL = '*',
  Graphs = 'graphs',
  Layouts = 'layouts',
  Queries = 'queries',
  Search = 'search',
  Export = 'export',
  Columns = 'columns',
  Autocomplete = 'autocomplete',
  QueryTemplates = 'query-templates',
  Debug = 'debug',
  UniqueUsers = 'unique-users',
  ColumnLinks = 'links',
  Stats = 'stats',
  Aliases = 'varmap',
}
